export const DATA_HOOKS = {
  OVERLAY: 'drawer-overlay',
  CONTENT: 'drawer-content',
  HANDLE: 'drawer-handle',
};
